export default __webpack_public_path__ + "static/shops-img-1-83c19d269302a0b16bb6ace0f52ff49c.jpg";